"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectionMenu_1 = require("./SelectionMenu");
exports.default = SelectionMenu_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/SelectionMenu/index.js
// module id = 1809
// module chunks = 8